exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valores-objeto {\r\n\tfont-size: 20px;\r\n\tmargin-top: 5px;\r\n\ttext-transform: capitalize;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/formulario/cabecera-formulario/cabecera-formulario.component.css
// module id = ../../../../../src/app/components/formulario/cabecera-formulario/cabecera-formulario.component.css
// module chunks = main